var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"graphBar",style:(("height: " + (this.height) + " px;")),attrs:{"id":"graphBar"}},[_c('h2',{attrs:{"id":"graphBarTitle"}},[_vm._v(_vm._s(_vm.title))]),_c('Plotly',{ref:"plotly",attrs:{"id":"graph","data":_vm.datasets,"layout":{
      autosize:true,
      yaxis: {range: _vm.range},
      barmode: 'group',
      margin: {l: 50, r: 50, b: 50, t: 50, pad: 4},
      font: {color:'#254558', size: 10, family: 'Karla'}
  }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }